import { decorateMovableWithBtnControl } from '@/templating/movables/movable-mover-contols'
import Moveable from 'moveable'
import { TControl } from '@/templating/TControl'
import { ownerWrapper } from '@/templating/movables/movable-gui-helpers'
import { fireOnWindowLoadEventOnce } from '@/templating/page-events/listeners'
import { selectCurrentToMoveByArrows } from './movables/move-by-arrows.js'

const moveByArrowsInstanceWrapper = (thisInstance, dispatchTransform) =>
    selectCurrentToMoveByArrows(thisInstance, (x, y) => {
        const { transform } = thisInstance
        thisInstance.transform = transform.replace(
            /(?!=matrix)\(.+\)/g,
            (m) => {
                const [a, b, c, d, tx, ty] = m
                    .replace(/[()]/g, '')
                    .split(',')
                    .map(Number)
                return `(${a}, ${b}, ${c}, ${d}, ${tx + x}, ${ty + y})`
            }
        )
        dispatchTransform({ target: thisInstance.ref })
    })

export class TemplateMoveable extends TControl {
    static $selector = '[data-moveable]'
    static freezable = ['move']
    // static currentSelectedMoveable = this

    moveEnabled = true

    constructor(ref, container) {
        super(ref, 'moveable')
        this.container = container
        this.id = this.ref.getAttribute(TemplateMoveable.$selector.slice(1, -1))
    }

    set smart_transform(value) {
        if (!value || value.override === false) {
            return
        }
        this.smartUpdate(() => {
            const { scaleX = 1, scaleY = 1, translateX, translateY } = value
            const parentRect = this.ref.parentElement.getBoundingClientRect()
            const xByPx = (parentRect.width * translateX) / 100
            const yByPx = (parentRect.height * translateY) / 100
            this.transform = `matrix(${scaleX}, 0, 0, ${scaleY}, ${xByPx}, ${yByPx})`
        })
    }

    get transform() {
        return getComputedStyle(this.ref).transform
    }
    set transform(value) {
        this.ref.style.transform = value
        this.updateMovableBox()
    }

    setupReactivity() {
        super.isReactive = true
        const ownerDiv = ownerWrapper()
        this.moveable = new Moveable(ownerDiv, {
            target: this.ref,
            origin: false,
            draggable: true,
            scalable: true,
            keepRatio: true,
        })

        const applyTransform = ({ target, transform }) => {
            if (this.moveEnabled) {
                target.style.transform = transform
            }
        }
        const dispatchTransform = ({ target }) => {
            const [scaleX, , , scaleY, translateX, translateY] =
                getComputedStyle(target)
                    .transform.replace(/matrix\(|\)/g, '')
                    .trim()
                    .split(',')
                    .map(Number)

            const parentRect = this.ref.parentElement.getBoundingClientRect()
            const smartTransform = {
                scaleX,
                scaleY,
                // @TO-FIX: this should consider the size of the element as well... (better precision)
                translateX: (translateX * 100) / parentRect.width,
                translateY: (translateY * 100) / parentRect.height,
            }
            this.smart_transform = smartTransform
            const eventId = this.makeEventId()
            this.dispatch(this.id, 'transform', target.style.transform, eventId)
            this.dispatch(this.id, 'smart_transform', smartTransform, eventId)
        }

        this.moveable.on({
            drag: applyTransform,
            scale: applyTransform,
            dragEnd: dispatchTransform,
            scaleEnd: dispatchTransform,
        })

        decorateMovableWithBtnControl({
            movable: this.moveable,
            container: ownerDiv,
            events: ['drag', 'scale'],
            iconColor: '#4af',
            targetName: this.id,
            targetControl: this,
            onMoveByArrows: () =>
                moveByArrowsInstanceWrapper(this, dispatchTransform),
        })

        // @Fix: movable need to be "refreshed" if load event happens after setupReactivity fired
        fireOnWindowLoadEventOnce(() => this.updateMovableBox())

        // Enable to move by arrows
        this.ref.addEventListener('click', () => {
            moveByArrowsInstanceWrapper(this, dispatchTransform)
        })
    }

    updateMovableBox() {
        if (this.isReactive && this.moveable) {
            this.moveable.updateRect()
        }
    }

    onDestroy() {
        if (this.moveable) {
            this.moveable.destroy()
        }
    }
}
